import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Hawaiian() {
  return (
    <ApiCommunityDirectoryPage
      community="Hawaiian"
      eyebrow="Hawaiian community guide"
      title="Hawaiian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Hawaiian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Hawaiian community guide?"
      modalIdPrefix="hawaiian-directory"
    />
  );
}
